var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 9.5,
    fill: "white",
    stroke: "#D6E1F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7024 31.9919C11.1849 31.8112 11.0042 31.4456 11.0001 30.9076C10.9919 28.8335 11.7147 27.0879 13.2795 25.7202C16.8651 22.5824 22.5658 24.2786 23.8719 28.8622C24.0855 29.6138 24.1553 30.3778 24.1225 31.154C24.1019 31.5976 23.8267 31.8522 23.4283 31.9919C19.5183 31.9919 15.6124 31.9919 11.7024 31.9919Z",
    fill: "#011367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.996 26.948C31.9754 26.9891 31.9508 27.0261 31.9303 27.0671C31.7742 27.4121 31.5154 27.6093 31.1335 27.6093C29.2277 27.6134 27.322 27.6134 25.4163 27.6093C25.3547 27.6093 25.2602 27.5518 25.2356 27.4984C24.3854 25.5269 22.9931 24.0812 21.0627 23.1489C21.0463 23.1407 21.0298 23.1284 21.0011 23.1078C21.3502 22.5985 21.7732 22.1673 22.2579 21.8017C25.827 19.1074 31.0595 21.1487 31.881 25.5475C31.9262 25.7816 31.959 26.0157 32.0001 26.2498C31.996 26.4839 31.996 26.7139 31.996 26.948Z",
    fill: "#011367"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5676 22.3644C15.3867 22.3562 13.6247 20.5983 13.6288 18.4339C13.6371 16.2406 15.4072 14.4828 17.6005 14.4951C19.7567 14.5033 21.5064 16.2899 21.4982 18.4708C21.4899 20.6148 19.7157 22.3726 17.5676 22.3644Z",
    fill: "#011367"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2422 14.947C30.2422 17.1032 28.472 18.8734 26.3198 18.8693C24.1512 18.8652 22.381 17.1115 22.3769 14.9634C22.3687 12.762 24.1307 11 26.3445 11C28.4884 11 30.2422 12.7743 30.2422 14.947Z",
    fill: "#011367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.24f3b49a304629e0389ac57f39c69ee4.svg";
export { ForwardRef as ReactComponent };